import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

const ignoreOnboardingStepsFg = atom<boolean>({
  key: "ignoreOnboardingStepsFg",
  default: false,
});

export const useIgnoreOnboardingValue = () => useRecoilValue(ignoreOnboardingStepsFg);
export const useSetIgnoreOnboarding = () => useSetRecoilState(ignoreOnboardingStepsFg);

const badNetworkQuality = atom<boolean>({
  key: "badNetworkQuality",
  default: false,
});

export const useBadNetworkQualityState = () => useRecoilState(badNetworkQuality);
export const useBadNetworkQualityValue = () => useRecoilValue(badNetworkQuality);
export const useSetBadNetworkQuality = () => useSetRecoilState(badNetworkQuality);

const haveNewNotifications = atom<boolean>({
  key: "haveNewNotifications",
  default: false,
});

export const useHaveNewNotificationsValue = () => useRecoilValue(haveNewNotifications);
export const useSetHaveNewNotifications = () => useSetRecoilState(haveNewNotifications);
